const getters = {
    vehicles: (state) => state.vehicles,
    vehicleId: (state) => state.vehicleId,
    loading: state => state.loading
};

export default getters;